export enum SearchTypes {
    Simple   = 'simple',
    Advanced = 'advanced'
}